"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSubRegions = void 0;
const countryToSubRegionMapping = {
    ES: [
        {
            iso2: 'GI',
            mdmId: 76,
            iso3: 'GIB',
        },
        {
            iso2: 'AD',
            mdmId: 1,
            iso3: 'AND',
        },
    ],
};
const getSubRegions = (countries) => {
    let subRegions = [];
    countries.forEach((country) => {
        if (country in countryToSubRegionMapping) {
            subRegions = [...countryToSubRegionMapping[country]];
        }
    });
    return subRegions;
};
exports.getSubRegions = getSubRegions;
